import React from 'react';
import PortfolioBlock from './PortfolioBlock';
import { Box, Grid } from '@mui/material';
import { info } from '../../assets/info/Info';

export default function Portfolio() {
  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center">
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
        {info.portfolio.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <PortfolioBlock
              image={project.image}
              live={project.live}
              source={project.source}
              title={project.title}
              subtitle={project.subtitle}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
